import View from './View'
import gsap from 'gsap'

/**
 * Edition home = the "ZNAKI" installation (see ../playground).
 * The whole experience lives inside a single <canvas>, so the view
 * animation is only a cross-fade of the container.
 */
class HomePlayView extends View {

  constructor(id) {
    super(id)
  }
  /**
  * animate in (show)
  **/
  show(container) {
    super.show(container)
    gsap.killTweensOf(container);
    gsap.set(container, {opacity: 0});
    gsap.to(container, {duration: .4, opacity: 1, ease: "sine.out"});
  }
  /**
  * animate out (hide)
  **/
  hide(container) {
    super.hide(container)
    gsap.killTweensOf(container);
    gsap.to(container, {duration: .3, opacity: 0, ease: "sine.in"});
  }

}

export default HomePlayView
